import { render } from "./CashBook.vue?vue&type=template&id=6a13aebd&scoped=true"
import script from "./CashBook.vue?vue&type=script&lang=js"
export * from "./CashBook.vue?vue&type=script&lang=js"

import "./CashBook.vue?vue&type=style&index=0&id=6a13aebd&scoped=true&lang=css"

import exportComponent from "D:\\DockerProjects\\armt_pos_v2_docker\\client\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6a13aebd"]])

export default __exports__